export const DEFAULT_TOKEN_LIST_URL = 'archerswap'

export const DEFAULT_LIST_OF_LISTS: string[] = [DEFAULT_TOKEN_LIST_URL]
